// extracted by mini-css-extract-plugin
export var activityContainer = "_nd-0";
export var typingIndicatorContainer = "_nd-1";
export var typingIndicatorDot = "_nd-2";
export var wave = "_nd-3";